'use es6';

import Actions from 'AdsUI/lib/Actions';
import { Map as ImmutableMap, List } from 'immutable';
import LeadFormRecord from 'AdsUI/records/ad-management/LeadFormRecord';
import { Networks } from 'AdsUI/lib/Constants';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.LEAD_FORMS_FETCH_SUCCEEDED:
      {
        const {
          forms,
          path
        } = payload;
        return state.setIn(path, List(forms.map(LeadFormRecord.fromNetworkLeadForm.bind(null, path[0]))));
      }

    case Actions.LEAD_FORMS_FETCH_FAILED:
      {
        const {
          meta
        } = action;
        const {
          path
        } = payload; // If we're being rate-limited, keep existing results

        if (state.hasIn(path) && meta && meta.responseJSON && meta.responseJSON.errorType === 'RATE_LIMIT') {
          return state;
        }

        return state.setIn(path, List());
      }

    case Actions.LEAD_FORMS_CREATE_SUCCEEDED:
      {
        const {
          form,
          path
        } = payload;
        return state.updateIn(path, forms => forms.push(form));
      }

    case Actions.LEAD_AD_CREATION_STATE_SET:
      {
        const {
          network,
          state: {
            form,
            adAccountId,
            leadSyncingEntityId
          }
        } = payload;

        if (!form) {
          return state;
        }

        return state.setIn([network, network === Networks.FACEBOOK ? leadSyncingEntityId : adAccountId], List([form]));
      }

    default:
      return state;
  }
});